import { render } from "./DeleteDepartmentModal.vue?vue&type=template&id=698d5535&scoped=true"
import script from "./DeleteDepartmentModal.vue?vue&type=script&lang=js"
export * from "./DeleteDepartmentModal.vue?vue&type=script&lang=js"

import "./DeleteDepartmentModal.vue?vue&type=style&index=0&id=698d5535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698d5535"]])

export default __exports__